module.exports = __webpack_public_path__ + "static/media/img_solution.febc904a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/solution/images/img_solution.jpg
// module id = 255
// module chunks = 4